// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_1mufZ","container":"index_container_2uUDT","googleSign":"index_googleSign_wATf9","footerNav":"index_footerNav_3zlRq"};